/**
 * Atende os comandos de voz do sistema que não são de uma tela só (spec 011,
 * 03/10/2026; ver `commands.ts`):
 *   - "Atlas, manda entrar" / "chama o próximo" → o MESMO aviso genérico do
 *     botão "Mandar entrar" (pop-up na recepção, com a sala salva do médico);
 *   - "Atlas, abre a agenda" / "volta pra agenda" → a agenda.
 * Montado no Shell, ao lado dos outros vigias. O bipe diz se foi.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ReceptionAlertService } from '@/services/firebase/receptionAlert';
import { useComandoVoz } from '@/services/voice/wake/commands';
import { playVoiceTone } from '@/utils/chime';

/** Sala salva do médico — mesma chave da fila, da agenda e da gaveta. */
const ROOM_STORAGE_KEY = (uid: string) => `dratento.queue.room.${uid}`;

export const VoiceCommandWatcher = () => {
  const { clinicId, user } = useAuth();
  const navigate = useNavigate();

  useComandoVoz(
    'mandarEntrar',
    () => {
      if (!clinicId || !user) return false;
      let room: string | undefined;
      try {
        room = localStorage.getItem(ROOM_STORAGE_KEY(user.uid))?.trim() || undefined;
      } catch {
        room = undefined;
      }
      return ReceptionAlertService.sendCallNext(clinicId, {
        room,
        sentByUid: user.uid,
        sentByName: user.displayName || user.email || undefined,
      })
        .then(() => {
          playVoiceTone('pronto');
          return true;
        })
        .catch((err) => {
          console.error('[voz] "manda entrar" falhou:', err);
          playVoiceTone('encerrado');
          return false;
        });
    },
    !!clinicId && !!user,
  );

  useComandoVoz('agenda', () => {
    playVoiceTone('pronto');
    navigate('/agenda');
    return true;
  });

  return null;
};
